export default {
  MuiToggleButtonGroup: {
    root: {
      backgroundColor: '#ffffff',
    },
  },
  MuiToggleButton: {
    root: {
      '&.Mui-selected': { backgroundColor: '#E0F2F1' },
      '&.Mui-selected:hover': { backgroundColor: '#E0F2F1 !important' },
    },
    label: { color: '#26A69A' },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/ToggleButtonGroup.js